import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const DISCOUNT_CODES_DISCOUNT_CODE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/discount-codes',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:DiscountCodes',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.DiscountCodes',
      },
    ]);
  };
}
